import React from 'react';
import { BodyTextSmall, HeadingText30 } from '@modernhealth/vital-components';
import { FormattedMessage } from 'react-intl';

import { TopicCard } from './TopicCard';
import { CircleTopicFragment } from '../documents/topic.generated';

export const TopicHeaderCard: React.FC<{
  topic: CircleTopicFragment;
  sessionId?: string;
}> = ({ topic, sessionId }) => {
  return (
    <div css={{ height: '100%' }}>
      <TopicCard
        topic={topic}
        header={HeadingText30}
        body={BodyTextSmall}
        sessionId={sessionId}
        info={
          <>
            {' · '}
            <FormattedMessage
              defaultMessage="{duration} min"
              description="min is the English abbreviation for minutes"
              values={{ duration: topic.duration }}
            />
          </>
        }
      />
    </div>
  );
};
